import * as React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import AccountCircleOutlined from '@mui/icons-material/AccountCircleOutlined';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';

interface AccountMenuProps {
  /** Defaults to Okta sign-out. The layout passes its own handler to also clear local user data. */
  onLogout?: () => void;
}

export default function AccountMenu({ onLogout }: AccountMenuProps) {
  const { oktaAuth } = useOktaAuth();
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
  const open = Boolean(anchor);

  const handleLogout = () => {
    setAnchor(null);
    if (onLogout) onLogout();
    else void oktaAuth.signOut();
  };

  return (
    <>
      <Tooltip title='Account'>
        <IconButton
          aria-label='Account menu'
          aria-haspopup='menu'
          aria-controls={open ? 'account-menu' : undefined}
          aria-expanded={open || undefined}
          onClick={(event) => setAnchor(event.currentTarget)}
        >
          <AccountCircleOutlined />
        </IconButton>
      </Tooltip>
      <Menu
        id='account-menu'
        anchorEl={anchor}
        open={open}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutOutlined fontSize='small' />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
